import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"
import * as Basic from "../../../Modules/BasicFields"

export default function Hivemind( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const [ target, setTarget ] = useState(null)

    const requiredData = [
        target
    ]

    const cfgName = "pulse_hivemind_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setTarget( cfg.target || "" )
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.target = target

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ target ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <> 
            <SettingsGroup name="Behaviour">
                <Basic.StringInput name="Target Expression" value={target} setValue={setTarget}/>
            </SettingsGroup>
        </>
    )
}
